import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CliConnectSectionProps {
  projectSlug: string;
}

export function CliConnectSection({ projectSlug }: CliConnectSectionProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const command = `rai init --slug ${projectSlug}`;

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable or permission denied — silent no-op
    }
  }, [command]);

  return (
    <div className="flex items-center gap-3">
      <code className="flex-1 rounded-md bg-muted px-3 py-2 text-sm font-mono">
        {command}
      </code>
      <Button
        variant="outline"
        size="sm"
        onClick={() => void handleCopy()}
        aria-label={t("projectPortal.config.cli.copy")}
      >
        {copied ? (
          <>
            <Check className="mr-1 h-4 w-4" />
            {t("projectPortal.config.cli.copied")}
          </>
        ) : (
          <>
            <Copy className="mr-1 h-4 w-4" />
            {t("projectPortal.config.cli.copy")}
          </>
        )}
      </Button>
    </div>
  );
}
